import Aegis, { WebConfig } from '@tencent/aegis-web-sdk';
import { getUid } from '@tencent/docs-login';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { getAegisExtraConfig } from '../js-error/tam-report';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

export default class AegisWrapper {
    private static instance;
    public static getInstance(): AegisWrapper {
        if (!AegisWrapper.instance) {
            AegisWrapper.instance = new AegisWrapper();
            AegisWrapper.instance.init();

            (window as any).AegisWrapper = AegisWrapper.instance;
        }
        return AegisWrapper.instance;
    }
    /**
     * 监控系统
     * @type {Aegis}
     * @memberof ConfigManager
     */
    public aegis: Aegis;

    /**
     * 监控系统是否已经初始化好
     * @type {boolean}
     * @memberof AegisWarpper
     */
    public initialized: boolean;

    /**
     * 初始化
     * @memberof AegisWarpper
     */
    public init(): void {
        const extraConfig = getAegisExtraConfig();
        const param: WebConfig = {
            reportApiSpeed: true,
            reportAssetSpeed: true,
            spa: true,
            id: getCacConfigByKey('custom.common.aegisID', 'ZvszvAcZRLGIWozYaO'),
            /**
             * 日志拦截
             * 仅上报自定义事件和event，目前业务逻辑仅用到了aegis.time、aegis.reportTime、aegis.reportEvent三个接口
             * 错误日志在src/slide/infrastructure/module/dependent/report/js-error/js-error-monitor.ts文件中已经做了手动上报
             * 错误日志可能会受其他包的影响导致数据上报失败或者与tdw上报数据不一致，所以改为手动上报
             * 只收集master、release、hotfix分支的日志
             */
            beforeRequest(data) {
                return (data.logType === 'custom' || data.logType === 'event');
                // return /^(master|hotfix|release)/.test(global.__globalReleaseVersion)
                //     && (data.logType === 'custom' || data.logType === 'event');
            },
            uin: getUid(),
            version: extraConfig.version,
        };
        if (ENV.IS_TEST) {
            param.env = Aegis.environment.test;
            param.repeat = 1;
        }
        this.aegis = new Aegis(param);
        Object.assign(window, { aegis: this.aegis });
        this.initialized = true;
    }
}
